import { Tag } from 'antd';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { AccessStatus } from '@/modules/api/codegen';
import type { Theme } from '@/styles/theme';

import * as felaRules from './NameWithStatusTag.rules';

const getTagColor = (theme: Theme, status?: AccessStatus) => {
    switch (status) {
        case AccessStatus.active:
            return theme.colors.alertsInfoText;
        case AccessStatus.pending:
            return theme.colors.alertsWarningText;
        default:
            return theme.colors.foregroundsTertiary;
    }
};

export interface NameWithStatusTagProps {
    name: string;
    status?: AccessStatus;
}

export const NameWithStatusTag = ({ name, status }: NameWithStatusTagProps) => {
    const { css, theme } = useFela<Theme>();

    return (
        <div className={css(felaRules.nameWithTag)}>
            {name}
            <Tag color={getTagColor(theme, status)}>
                <FormattedMessage id={`user-administration.status.${status ?? 'inactive'}`} />
            </Tag>
        </div>
    );
};
